/**
 * Central error codes - mirrors backend ErrorCode enum.
 * Never check HTTP status directly; use these codes.
 */
export const ErrorCode = {
    // Generic
    UNKNOWN: 'UNKNOWN',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    RATE_LIMITED: 'RATE_LIMITED',
    INTERNAL: 'INTERNAL',
    INTERNAL_ERROR: 'INTERNAL_ERROR',

    // Auth
    AUTH_REQUIRED: 'AUTH_REQUIRED',
    INVALID_TOKEN: 'INVALID_TOKEN',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    SESSION_EXPIRED: 'SESSION_EXPIRED',
    STEP_UP_REQUIRED: 'STEP_UP_REQUIRED',

    // Authorization
    INSUFFICIENT_PERMISSION: 'INSUFFICIENT_PERMISSION',
    ROLE_REQUIRED: 'ROLE_REQUIRED',

    // Business
    PAYMENT_NOT_FOUND: 'PAYMENT_NOT_FOUND',
    PAYMENT_GATEWAY_ERROR: 'PAYMENT_GATEWAY_ERROR',
    PAYMENT_EXPIRED: 'PAYMENT_EXPIRED',
    PAYMENT_ALREADY_COMPLETED: 'PAYMENT_ALREADY_COMPLETED',
    PAYMENT_FAILED: 'PAYMENT_FAILED',
    PAYMENT_PROVIDER_UNAVAILABLE: 'PAYMENT_PROVIDER_UNAVAILABLE',
    INSUFFICIENT_BALANCE: 'INSUFFICIENT_BALANCE',
    CERTIFICATE_PENDING: 'CERTIFICATE_PENDING',
    EKYC_NOT_APPROVED: 'EKYC_NOT_APPROVED',
    EKYC_NOT_FOUND: 'EKYC_NOT_FOUND',
    EKYC_INVALID_STATE: 'EKYC_INVALID_STATE',
    EVIDENCE_NOT_FOUND: 'EVIDENCE_NOT_FOUND',
    EVIDENCE_INVALID_STATE: 'EVIDENCE_INVALID_STATE',
    CERTIFICATE_NOT_FOUND: 'CERTIFICATE_NOT_FOUND',
    CSR_INVALID: 'CSR_INVALID',
    INVALID_STATE_TRANSITION: 'INVALID_STATE_TRANSITION',
    RESOURCE_ALREADY_EXISTS: 'RESOURCE_ALREADY_EXISTS',
    RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    DATABASE_UNAVAILABLE: 'DATABASE_UNAVAILABLE',
    TRANSACTION_FAILED: 'TRANSACTION_FAILED',
    SMS_PROVIDER_FAILED: 'SMS_PROVIDER_FAILED',
    IDENTITY_PROVIDER_TIMEOUT: 'IDENTITY_PROVIDER_TIMEOUT',
    PKI_PROVIDER_ERROR: 'PKI_PROVIDER_ERROR',
    TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
    INVALID_OTP: 'INVALID_OTP',
    OTP_EXPIRED: 'OTP_EXPIRED',
    OTP_RATE_LIMITED: 'OTP_RATE_LIMITED',
    TICKET_NOT_FOUND: 'TICKET_NOT_FOUND',
    OPERATION_NOT_FOUND: 'OPERATION_NOT_FOUND',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    ACCOUNT_DEACTIVATED: 'ACCOUNT_DEACTIVATED',
    ACCOUNT_BLOCKED: 'ACCOUNT_BLOCKED',
    INVALID_NATIONAL_CODE: 'INVALID_NATIONAL_CODE',
    NATIONAL_CODE_TAKEN: 'NATIONAL_CODE_TAKEN',
};

// Sets for quick checks
export const AUTH_CODES = new Set([
    ErrorCode.AUTH_REQUIRED,
    ErrorCode.UNAUTHORIZED,
    ErrorCode.INVALID_TOKEN,
    ErrorCode.TOKEN_EXPIRED,
    ErrorCode.SESSION_EXPIRED,
]);

export const RETRYABLE_CODES = new Set([
    ErrorCode.PAYMENT_PROVIDER_UNAVAILABLE,
    ErrorCode.DATABASE_UNAVAILABLE,
    ErrorCode.IDENTITY_PROVIDER_TIMEOUT,
    ErrorCode.PKI_PROVIDER_ERROR,
    ErrorCode.TRANSACTION_FAILED,
]);
